import type { FC } from "react";

type SearchEmailStatsProps = {
  totalCount: number;
  displayCount: number;
  invisibleCount: number;
  favoriteCount: number;
};

export const SearchEmailStats: FC<SearchEmailStatsProps> = ({
  totalCount,
  displayCount,
  invisibleCount,
  favoriteCount,
}) => {
  return (
    <div className="flex items-center gap-6 text-sm">
      <div className="flex items-center gap-2">
        <span className="text-base-content/60">総件数:</span>
        <span className="font-semibold">{totalCount.toLocaleString()}</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-base-content/60">表示:</span>
        <span className="font-semibold">{displayCount.toLocaleString()}</span>
      </div>
      {invisibleCount > 0 && (
        <div className="flex items-center gap-2">
          <span className="text-base-content/60">非表示:</span>
          <span className="font-semibold">
            {invisibleCount.toLocaleString()}
          </span>
        </div>
      )}
      <div className="flex items-center gap-2">
        <span className="text-base-content/60">お気に入り:</span>
        <span className="font-semibold">{favoriteCount.toLocaleString()}</span>
      </div>
    </div>
  );
};
